module.exports = __webpack_public_path__ + "img/team-7.5a25757.webp";